
const token = localStorage.getItem("auth_token");
const admin = localStorage.getItem("admin")
const vm = localStorage.getItem("vm")
const imach = localStorage.getItem("imach")
const maintainer = localStorage.getItem("maintainer")
const company = localStorage.getItem("company")
const parent_company = localStorage.getItem("parent_company")

export default {
  token,
  authenticated: !!token,
  admin,
  vm,
  imach,
  maintainer,
  company,
  parent_company
}